import { currentUserAPI } from "@/services/api";
import { get } from "@/services/request";
import { VENDOR_ROLE, CLIENT_ROLE, ADMIN_ROLE } from "@/services/constants";

// initial state
const state = {
  currentUser: null,
  assumedRole: VENDOR_ROLE
};

const getters = {
  isVendorUser: state =>
    state.currentUser && Symbol.for(state.currentUser.role) === VENDOR_ROLE,
  isClientUser: state =>
    state.currentUser && Symbol.for(state.currentUser.role) === CLIENT_ROLE,
  isAdminUser: state =>
    state.currentUser && Symbol.for(state.currentUser.role) === ADMIN_ROLE,
  hasMonitoringAccess: state =>
    state.currentUser && state.currentUser.hasMonitoringAccess,
  isAssumingClientRole: state => state.assumedRole === CLIENT_ROLE
};

// mutations
const mutations = {
  setCurrentUser(state, value) {
    state.currentUser = value;
    state.currentUser.assumedRole = state.assumedRole;
  }
};

// actions
const actions = {
  loadCurrentUser({ commit }) {
    return get(currentUserAPI)
      .then(response => {
        if (response && response.data) {
          commit("setCurrentUser", response.data);
          return response.data;
        }
      })
      .catch(err => console.error("Error loading current user", err));
  },
  assumeVendorRole() {
    state.assumedRole = VENDOR_ROLE;
    if (state.currentUser) state.currentUser.assumedRole = state.assumedRole;
  },
  assumeClientRole() {
    state.assumedRole = CLIENT_ROLE;
    if (state.currentUser) state.currentUser.assumedRole = state.assumedRole;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
